import React, { useEffect } from 'react';

import { Flex, Text } from '@rover/kibble/core';
import { emitAnalyticsEvent } from '@rover/rsdk/src/modules/Analytics';

import { TrainingQualificationsModalLoads } from '../../../events/analyticsEvents';

type QualificationsModalProps = {
  qualifications: string;
  firstName: string;
};

const QualificationsModal: React.FC<QualificationsModalProps> = ({ qualifications, firstName }) => {
  useEffect(() => {
    emitAnalyticsEvent(new TrainingQualificationsModalLoads());
  }, []);

  return (
    <Flex flexDirection="column" alignContent="flex-start" gap="4x" marginBottom="8x">
      <Text fontWeight="semibold" size="300">
        {/* TODO (DEV-104195): Translate below text after training pilot launch */}
        Credentials
      </Text>
      <Text>
        {/* TODO (DEV-104195): Translate below text after training pilot launch */}
        All trainers on Rover have indicated that they have certification or formal dog training
        education.
      </Text>
      <Flex flexDirection="column">
        {/* TODO (DEV-104195): Translate below text after training pilot launch */}
        <Text fontWeight="semibold">{firstName}'s Credentials</Text>
        <Text>{qualifications}</Text>
      </Flex>
    </Flex>
  );
};

export default QualificationsModal;
